/** @jsx jsx */
import React, { useContext, useState } from 'react'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  getValidYearRange,
} from 'core'
import { connect } from 'react-redux'
import { isValidYearRange, rowHeaderRender, severity } from 'core/utils'
import { jsx } from '@emotion/core'
import { ErrorContext, SpinContext } from 'context'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { intCol, strCol, dateCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, Table, message, Tabs } from 'antd'
import {
  getSwitchboardLOG,
  getAuthorization,
  exportData,
  getSwitchboardValidationLog,
  getCredentials,
} from 'api/pgads'
import querystring from 'querystring'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import moment from 'moment'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
const columns = download => [
  // {
  //   title: 'Report Name',
  //   dataIndex: 'fileName',
  //   key: 'name',
  // },
  {
    title: 'Transdate',
    // dataIndex: 'fileName',
    dataIndex: 'transDate',
    key: 'transDate',
    width: 50,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  },
  {
    title: 'File Type',
    dataIndex: 'fileType',
    key: 'fileType',
    width: 30,
    // sorter: (a, b) => a.dataSize < b.dataSize,
    // multiple: 1,
  },
  {
    title: 'Action',
    dataIndex: 'fileType',
    key: 'x',
    render: (text, record) => {
      return <a onClick={_ => download(text, record.transDate)}>Download</a>
    },
    width: 50,
  },
  {
    title: 'Modifier',
    dataIndex: 'modificationInfo',
    key: 'modifier',
    width: 50,
    render: modificationInfo => {
      return modificationInfo.user
    },
  },
  {
    width: 70,
    title: 'Modified Date',
    dataIndex: 'modificationInfo',
    key: 'modifieddate',
    render: modificationInfo => {
      const date = modificationInfo.modDate
      return moment(date.substring(0, date.indexOf('+'))).format(
        'MM/DD/YYYY HH:mm:ss'
      )
    },
  },
]

const Log = ({ apiTargetInfo, validYearRange }) => {
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  const [validationData, setValidationData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState([])

  const downloadFile = (date, type) => {
    const URL = `${
      apiTargetInfo.baseUrl
    }/switchboard/download-log?${querystring.stringify({
      // date: date.format('YYYY-MM-DDTHH:mm:ss'),
      date,
      type,
    })}`
    return fetch(`${URL}`, {
      method: 'GET',
      ignoreAuth: true,
      ...getCredentials(apiTargetInfo),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
        // jwt: targetInfo.jwt == undefined ? null : targetInfo.jwt,
        ...getAuthorization(apiTargetInfo),
      },
      // body:JSON.stringify(data)
    })
      .then(response => {
        if (response.ok) return response
        else throw new Error('Something went wrong')
      })
      .then(response => response.blob())
      .then(blob =>
        exportData(
          blob,
          'application/pdf',
          decodeURIComponent(
            type + '-' + date.substring(0, date.indexOf('T')) + '.txt'
          )
        )
      )
      .catch(error => message.error('Error in Reports ' + error))
  }

  const download = (fileType, date) => downloadFile(date, fileType)

  const [selDate, setSelDate] = useState([moment(), moment()])

  const retrieve = ({ dates = selDate }) => {
    const isValid = isValidYearRange(validYearRange, dates[0], dates[1])
    if (!isValid) return
    setSpinning(false)
    getSwitchboardLOG(apiTargetInfo)(dates[0], dates[1]).fork(
      setError,
      data => {
        setData(data.sort((a, b) => moment(b.transDate) - moment(a.transDate)))
        setSpinning(false)
      }
    )

    getSwitchboardValidationLog(apiTargetInfo)(dates[0], dates[1]).fork(
      setError,
      data => {
        const datesBetween = []
        // datesBetween.push(dates[0]);
        const cr = dates[0].clone()
        while (cr <= dates[1]) {
          datesBetween.push(cr.clone())
          cr.add(1, 'days')
        }
        const swType = ['ONS', 'CNS', 'MNS', 'RNP', 'HNP', 'BNP']
        const newData = datesBetween
          .map(d =>
            swType.map(s => ({
              transdate: d.format('YYYY-MM-DD'),
              station: s,
              message: 'Not Imported',
            }))
          )
          .flat()

        const mrgeData = newData.map(d => {
          const fd = data.filter(
            f => f.transdate === d.transdate && f.station === d.station
          )
          if (fd.length > 0) return fd
          return d
        })

        setValidationData(mrgeData.flat())
        setSpinning(false)
      }
    )
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          Switchboard Files
        </Title>
        <DatePicker.RangePicker
          allowClear={false}
          // mode={['month', 'month']}
          // mode="decade"
          format="MM/DD/YYYY"
          value={selDate}
          // placeholder={['Start month', 'End month']}
          // open={openPicker}
          onChange={dates => {
            setSelDate(dates)
            setData([])
            setValidationData([])
          }}
          onPanelChange={dates => {
            setSelDate(dates)
          }}
        />
        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ dates: selDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content
            css={{
              height: height - 20,
              paddingTop: '10px',
              display: 'grid',
              gridTemplateColumns: '1fr',
            }}
          >
            <Tabs>
              <Tabs.TabPane key="main" tab="Log">
                <Table
                  dataSource={data}
                  columns={columns(download)}
                  pagination={false}
                  size="small"
                  scroll={{ y: height - 100 }}
                  rowKey="fileName"
                  onChange={_ => _}
                  onFilter={(value, record) =>
                    record.station.indexOf(value) === 0 ||
                    record.unit.indexOf(value) === 0 ||
                    record.entityid.indexOf(value) === 0
                  }
                />
              </Tabs.TabPane>
              <Tabs.TabPane key="validation" tab="Validation">
                <div style={{ minHeight: '100px', minWidth: '200px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={validationData}
                    headers={ImportLogHeaders}
                    altBgColor="#ebebeb"
                    altBy={d => d.transdate + '||' + d.station}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 130,
                      width: width - 60,
                      headerRowHeight: 30,
                    })}
                    sortOptions={[
                      {
                        ident: 'station',
                        display: 'Station',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transdate',
                        display: 'Transdate',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transhour',
                        display: 'Transhour',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const ImportLogHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  intCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
  strCol({
    ident: 'message',
    display: 'Message',
    isFiltered: true,
    width: 550,
  }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'entityid', display: 'Entityid', isKey: true }),
  intCol({ ident: 'errorcode', display: 'Errorcode', isKey: true }),
  intCol({
    ident: 'severity',
    display: 'Severity',
    isFiltered: true,
    ...toSelectionColProps(severity),
  }),
  modifierCol,
  modifiedDateCol,
]

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(Log)
